const ROUTE_NAME = Object.freeze({
  HOME: "home",
  LOGIN: "login",
  AUTH: "auth",
  OVERVIEW: "overview",
  /* User Profile */
  USER: "user",
  USER_PROFILE: "user-profile",

  /* Role Permission */
  ROLE_PERMISSION: "role-permission",
  ROLE_PERMISSION_LIST: "role-permission-list",
  ROLE_PERMISSION_DETAILS: "role-permission-details",
  ROLE_PERMISSION_NEW: "role-permission-new",

  /* Role Permission */
  DEVOPS: "devOps",
  DEVOPS_CREATE_ACCOUNT: "devOps-create-account",
  DEVOPS_ACCOUNT_LOGGER: "devOps-account-logger",
  // DEVOPS_NEW: "role-permission-new",

  // About Us
  IMPRINT: "imprint",
  TERMS_OF_USE: "terms-of-use",
  DATA_PROTECTION_STATEMENT: "data-protection-statement",
  COOKIES: "cookies",

  /* Table */
  TABLE: "table",
  TABLE_LIST: "table-list",

  TYPOGRAPHY: "typography",
  ICONS: "icons",
  MAPS: "maps",
  NOTIFICATIONS: "notifications",

  /* Error */
  ERROR_403: "403",
  ERROR_404: "404",
});

export { ROUTE_NAME };
